import axios from '../../axios'

export const getParticipations = () => {
  return axios.get('/participation')
}

export const getParticipationsAgro = () => {
  return axios.get('/participation/agro')
}

export const getParticipation = (id) => {
  return axios.get('/participation/' + id)
}

export const getParticipationAgro = (id) => {
  return axios.get('/participation/agro/' + id)
}

export const makeBidAgro = (id, data) => {
  return axios.post('/participation/agro/' + id + '/bid', data)
}
export const answer = (id, questionnaire) => {
  return axios.post('/participation/' + id + '/answer', questionnaire)
}

export const agree = (id) => {
  return axios.post('/participation/' + id + '/agree')
}

export const disable = (id) => {
  return axios.post('/participation/' + id + '/disable')
}

export const enable = (id) => {
  return axios.post('/participation/' + id + '/enable')
}

export const bids = (id, bids) => {
  return axios.post('/participation/' + id + '/bids', bids)
}



// WEBPACK FOOTER //
// ./src/api/production/participation/index.js